import PropTypes from "prop-types";
import ProductBadge from "../ProductBadge";
import styles from "./index.css";

const ProductImageContainer = ({ badgeType, children, forwardRef }) => (
  <div aria-hidden={true} className={styles.container} ref={forwardRef}>
    {children}
    {badgeType && <ProductBadge type={badgeType} />}
  </div>
);

ProductImageContainer.propTypes = {
  badgeType: PropTypes.oneOf(["MixMatch", "MoreColors"]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  forwardRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any })
  ])
};

ProductImageContainer.defaultProps = {
  badgeType: null,
  forwardRef: null
};

export default ProductImageContainer;
